/**
 * Apply a botAi decision onto a live entity (move vs AA vs cast).
 */
export function applyBotAiDecision(entity, decision) {
  if (!entity || !decision) return;
  if (decision.action === 'move') {
    if (typeof entity.moveTo === 'function') {
      entity.moveTo(decision.targetX, entity.y, decision.targetZ);
    }
    return;
  }
  if (decision.action === 'cast') {
    entity.pendingCast = {
      slot: decision.slot || 'Q',
      targetId: decision.targetEntity?.id || null,
      x: decision.targetX,
      z: decision.targetZ
    };
    return;
  }
  if (decision.action === 'attack' && decision.targetEntity) {
    if (typeof entity.issueAttackCommand === 'function') {
      entity.issueAttackCommand(decision.targetEntity);
    }
  }
}
